export const FETCH_MENULIST_REQUEST = 'FETCH_MENULIST_REQUEST'
export const FETCH_MENULIST_SUCCESS = 'FETCH_MENULIST_SUCCESS'
export const FETCH_MENULIST_FALIURE = 'FETCH_MENULIST_FALIURE'
